import { Box, Stack, Typography } from '@mui/material';
import { NumberBox } from './NumberBox';
import { FC } from 'react';
import { baseCardStyling, baseCardButtonStyling } from './styles';
import IncrementButton from './IncrementButton';

type GradientProps = {
  gradient: number;
  handleGradientChange: (value: number) => void;
  handleStaticGradientChange: (value: number) => void;
};

export const Gradient: FC<GradientProps> = ({
  gradient,
  handleGradientChange,
  handleStaticGradientChange,
}) => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: '#202123',
        height: '100%',
        padding: 2,
      })}
    >
      <Stack
        direction="column"
        spacing={2}
        className="w-full"
        justifyContent="center"
        alignContent="center"
        sx={(theme) => ({ height: '100%' })}
      >
        <Box>
          <Stack
            direction="column"
            className="w-full"
            justifyContent="center"
            alignItems="center"
          >
            <Typography
              variant="h5"
              sx={(theme) => ({ color: 'white', fontWeight: 'bold' })}
            >
              GRADIENT
            </Typography>
            <Typography
              variant="h5"
              sx={(theme) => ({ color: 'yellow', fontWeight: 'bold' })}
            >
              %
            </Typography>
          </Stack>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={(theme) => ({ height: '50px', marginTop: '0px !important' })}
        >
          {' '}
          <Typography
            sx={(theme) => ({
              color: 'white',
              fontSize: '4rem',
              fontWeight: 'bold',
            })}
          >
            {gradient}
          </Typography>
        </Box>
        {[9, 6, 3, 0].map((value) => (
          <NumberBox number={value} onClick={handleStaticGradientChange} />
        ))}
        <Box>
          <Stack
            direction="column"
            spacing={2}
            className="w-full"
            sx={(theme) => ({ height: '100px' })}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <IncrementButton
              text={'+'}
              onClick={() => handleGradientChange(1)}
            />
            <IncrementButton
              text={'-'}
              onClick={() => handleGradientChange(-1)}
            />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};
